import axios from '@/libs/api.request'

export const exportMemberInvite = (email, email_invited, s_date, e_date) => {
    const data = {
        "email": email,
        "email_invited": email_invited,
        "s_date": s_date,
        "e_date": e_date
    }
    return axios.request({
        url: '/api/admin/memberinvite/export',
        data,
        method: 'post'
    })
}